import React from 'react'
import DocumentTitle from 'react-document-title'
import { inject, observer } from 'mobx-react'
import { formatDate, formatNumber } from '@atheneum/api/dist/lib'
import propTypes from 'prop-types'
import MonthYearPicker from '@components/MonthPicker/MonthYearPicker'
import Spinner from '@components/spinner'
import Action from '@components/Action'
import Download from '@components/Icon/Download'

const CurrencyRates = ({ currencyRatesStore }) => (
  <DocumentTitle title='Created invoices | Atheneum Partners'>
    <div className='project-wrapper'>
      <div className='details-header'>
        <div className='info info--noLeft'>
          <div className='name-status-wrapper'>
            <h1>Currency Rates</h1>
          </div>
        </div>
        <div className='floating' />
      </div>
      <div className='invoice-wrapper animate-intro'>
        <div className='left-text pull-left'>
          <MonthYearPicker
            monthAndYear={currencyRatesStore.month}
            onChange={currencyRatesStore.onMonthChange}
          />
        </div>
        <div className='actions-wrapper m-b-xxl'>
          <ul className='actions left-list' />
          <ul className='actions right-list'>
            <li className='action m-t-md'>
              <Action onClick={currencyRatesStore.export}>
                <Download />
                <span>Export</span>
              </Action>
            </li>
          </ul>
        </div>
      </div>
      <div>
        {currencyRatesStore.loading ? (
          <Spinner />
        ) : (
          <table className='table-wrapper'>
            <thead>
              <tr>
                <th>Date</th>
                <th>EUR/USD</th>
                <th>EUR/GBP</th>
                <th>EUR/CNY</th>
                <th>EUR/HKD</th>
                <th>EUR/PKR</th>
                <th>EUR/KRW</th>
                <th>EUR/JPY</th>
                <th>EUR/SGD</th>
                <th>CNY/USD</th>
                <th>CNY/HKD</th>
                <th>USD/KRW</th>
              </tr>
            </thead>
            <tbody>
              {currencyRatesStore.currencyRates.map(cr => (
                <tr key={cr.id}>
                  <td>{formatDate(cr.date)}</td>
                  <td>{formatNumber(cr.eurToUsd, 6)}</td>
                  <td>{formatNumber(cr.eurToGbp, 6)}</td>
                  <td>{formatNumber(cr.eurToCny, 6)}</td>
                  <td>{formatNumber(cr.eurToHkd, 6)}</td>
                  <td>{formatNumber(cr.eurToPkr, 6)}</td>
                  <td>{formatNumber(cr.eurToKrw, 6)}</td>
                  <td>{formatNumber(cr.eurToJpy, 6)}</td>
                  <td>{formatNumber(cr.eurToSgd, 6)}</td>
                  <td>{formatNumber(cr.cnyToUsd, 6)}</td>
                  <td>{formatNumber(cr.cnyToHkd, 6)}</td>
                  <td>{formatNumber(cr.usdToKrw, 6)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </DocumentTitle>
)

CurrencyRates.propTypes = {
  currencyRatesStore: propTypes.object.isRequired
}

export default inject('currencyRatesStore')(observer(CurrencyRates))
